<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <a-input v-model="queryParams.itemCode" allowClear placeholder="请输入物料编码" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="大工序">
              <a-select v-model="queryParams.mainProcessCode" allowClear placeholder="请选择大工序">
                <a-select-option v-for="item in mainProcessOptions" :key="item.lookupCode" :value="item.lookupCode">
                  {{ item.lookupValue }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="子工序">
              <a-select v-model="queryParams.subProcessCode" allowClear placeholder="请选择子工序">
                <a-select-option v-for="item in subProcessOptions" :key="item.lookupCode" :value="item.lookupCode">
                  {{ item.lookupValue }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery">查询</a-button>
              <a-button class="ml8" @click="resetQuery">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiProductionProcessExport" ref="download" />
      <a-button type="primary" v-hasPermi="['bom:bomProductionProcess:add']" @click="handleAdd">新增</a-button>
      <a-button type="primary" v-hasPermi="['bom:bomProductionProcess:import']" @click="importExcelHandleOpen">导入</a-button>
      <a-button v-hasPermi="['bom:bomProductionProcess:export']" @click="handleExport">导出</a-button>
      <a-button v-hasPermi="['bom:bomProductionProcess:template']" @click="importTemplate">下载模板</a-button>
      <a-button
        type="danger"
        :disabled="selectedRowKeys.length === 0"
        v-hasPermi="['bom:bomProductionProcess:remove']"
        @click="handleBatchDelete"
      >
        批量删除
      </a-button>
    </div>

    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :rowSelection="rowSelection"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1200 }"
          @successCallBack="successCallBack"
        >
          <template slot="unitPrice" slot-scope="{ text }">
            <span>{{ text }}</span>
          </template>
          <template slot="operation" slot-scope="{ record }">
            <a v-hasPermi="['bom:bomProductionProcess:edit']" @click="handleEdit(record)">编辑</a>
            <a-divider type="vertical" />
            <a v-hasPermi="['bom:bomProductionProcess:remove']" @click="handleDelete(record)">删除</a>
          </template>
        </ls-api-table>

        <production-process-form ref="formRef" @success="handleOk" />

        <a-modal
          :title="upload.title"
          :visible="excelVisible"
          destroyOnClose
          @cancel="importExcelHandleCancel"
        >
          <a-upload-dragger
            name="file"
            accept=".xlsx, .xls"
            :multiple="false"
            :headers="upload.headers"
            :action="upload.url"
            @change="importExcelHandleChange"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">请将文件拖拽到此处上传</p>
            <p class="ant-upload-hint">支持单个文件上传，也可以点击后选择文件上传</p>
          </a-upload-dragger>
          <div slot="footer">
            <a-button @click="importExcelHandleCancel">关闭</a-button>
          </div>
        </a-modal>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import Cookies from 'js-cookie'
import { generateLsTableResData } from '@/utils/util.js'
import {
  apiProductionProcessDelete,
  apiProductionProcessExport,
  apiProductionProcessList
} from '@/api/mes/basedata/productionProcess'
import ProductionProcessForm from './components/production-process-form.vue'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  name: 'ProductionProcess',
  components: {
    DownloadModal,
    ProductionProcessForm
  },
  data () {
    const token = process.env.NODE_ENV === 'development' || localStorage.getItem('isFromSystemLogin') === 'true'
      ? localStorage.getItem('token')
      : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined
    return {
      apiProductionProcessExport,
      tableProps: {
        requestApi: generateLsTableResData(apiProductionProcessList, true),
        pageCurrent: true
      },
      queryParams: {
        itemCode: undefined,
        mainProcessCode: undefined,
        subProcessCode: undefined
      },
      columns: [
        { title: '物料编码', dataIndex: 'itemCode', align: 'center', width: 150 },
        { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 160, ellipsis: true },
        { title: '规格描述', dataIndex: 'specificationDesc', align: 'center', width: 180, ellipsis: true },
        { title: '大工序', dataIndex: 'mainProcess', align: 'center', width: 130 },
        { title: '子工序', dataIndex: 'subProcess', align: 'center', width: 130 },
        { title: '工价', dataIndex: 'unitPrice', scopedSlots: { customRender: 'unitPrice' }, align: 'center', width: 120 },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          stickyFixed: 'right',
          width: 140
        }
      ],
      mainProcessOptions: [],
      subProcessOptions: [],
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        }
      },
      excelVisible: false,
      upload: {
        title: '导入Excel',
        headers: { Authorization },
        url: process.env.VUE_APP_API_BASE_URL + '/bom/bomProductionProcess/import'
      }
    }
  },
  created () {
    this.loadLookupOptions()
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    loadLookupOptions () {
      this.getLookupList('MES_MAIN_PROCESS', 'mainProcessOptions')
      this.getLookupList('MES_SUB_PROCESS', 'subProcessOptions')
    },
    getLookupList (lookupType, target) {
      this.getLookupListData({ lookupType, current: 1, pageSize: 999 }).then(response => {
        this[target] = response.rows || []
      })
    },
    onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.dataTable.getData()
    },
    handleQuery () {
      this.onSearch()
    },
    resetQuery () {
      this.queryParams = {
        itemCode: undefined,
        mainProcessCode: undefined,
        subProcessCode: undefined
      }
      this.handleQuery()
    },
    handleAdd () {
      this.$refs.formRef.open()
    },
    handleEdit (record) {
      this.$refs.formRef.open(record)
    },
    handleDelete (record) {
      this.confirmDelete([record.id])
    },
    handleBatchDelete () {
      this.confirmDelete(this.selectedRowKeys)
    },
    confirmDelete (ids) {
      this.$confirm({
        title: '警告',
        content: '确定删除选中的生产工艺吗？',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          return apiProductionProcessDelete(ids.join(',')).then(response => {
            if (response.code === 200) {
              this.$message.success('删除成功')
              this.handleOk()
            } else {
              this.$message.error(response.msg || '删除失败')
            }
          })
        }
      })
    },
    handleOk () {
      this.selectedRowKeys = []
      this.selectedRows = []
      if (this.$refs.dataTable && this.$refs.dataTable.onClear) {
        this.$refs.dataTable.onClear()
      }
      this.onSearch()
    },
    successCallBack () {
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    importExcelHandleOpen () {
      this.excelVisible = true
    },
    importExcelHandleCancel () {
      this.excelVisible = false
      this.handleQuery()
    },
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status === 'done') {
        const response = info.file.response || {}
        if (response.code === 200) {
          this.$message.success(`${info.file.name}: ${response.msg}`)
          this.importExcelHandleCancel()
        } else {
          this.$message.error(`${info.file.name}: ${response.msg || '导入失败'}`)
        }
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: 导入失败`)
      }
    },
    importTemplate () {
      this.download('bom/bomProductionProcess/template', {}, `生产工艺导入模板_${new Date().getTime()}.xlsx`)
    },
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less">
.ml8 {
  margin-left: 8px;
}
</style>
